
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extensions/dbt-observability",
      function () {
        return require("private-next-pages/extensions/dbt-observability.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extensions/dbt-observability"])
      });
    }
  